module.exports = __webpack_public_path__ + "static/logo-2b3076013e4ea72fa1aaeee2fdaa8ba9.png";